import { AnyAction, Dispatch } from 'redux'
import {
  setTemplatePageErrorMessage,
  setTemplateReportNameRuleErrorMessage,
} from 'src/state/ducks/templates/actions'
import {
  setMasterErrorMessage,
  setTemplateNameErrorMessage,
} from 'src/state/ducks/templates/editTemplate/actions'
import { setTemplateHintErrorMessage } from 'src/state/ducks/templates/templateHints/actions'
import { ExhaustiveError } from 'src/util/error'
import { runValidations } from './index'
import { ValidateParams, ValidationError } from './types'

/**
 * エラーを種類ごとにdispatchにマッピング
 */
const dispatchError = (
  dispatch: Dispatch<AnyAction>,
  error: ValidationError,
): void => {
  switch (error.type) {
    case 'template':
      dispatch(setTemplateNameErrorMessage(error.message))
      break
    case 'page':
      dispatch(setTemplatePageErrorMessage(error.message))
      break
    case 'hint':
      dispatch(setTemplateHintErrorMessage(error.message))
      break
    case 'reportName':
      dispatch(setTemplateReportNameRuleErrorMessage(error.message))
      break
    case 'master':
      dispatch(setMasterErrorMessage(error.message))
      break
    default:
      throw new ExhaustiveError(error.type)
  }
}

/**
 * バリデーション実行 + エラーのdispatch
 * @returns バリデーションが成功した場合はtrue、失敗した場合は最初のエラータイプを返す
 */
export const validateAndDispatch = (
  dispatch: Dispatch<AnyAction>,
  params: ValidateParams,
): true | ValidationError['type'] => {
  // すべてのエラーメッセージをクリア
  dispatch(setTemplateNameErrorMessage(''))
  dispatch(setTemplatePageErrorMessage(''))
  dispatch(setTemplateHintErrorMessage(''))
  dispatch(setTemplateReportNameRuleErrorMessage(''))
  dispatch(setMasterErrorMessage(''))

  const errors = runValidations(params)

  if (errors.length > 0) {
    // NOTE: 同じタイプのエラーが複数ある場合、最後のエラーメッセージだけが表示される。
    // 既存の振る舞いに合わせているだけで、深い理由はない。
    errors.forEach(error => {
      dispatchError(dispatch, error)
    })
    // 最初のエラータイプを返す
    const firstError = errors[0]
    if (firstError) {
      return firstError.type
    }
  }

  return true
}
